import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface CreateContainerData {
  name: string;
  schemaUuid: string;
  dynamic?: boolean;
}

interface CreateContainerResponse {
  uuid: string;
}

export function useCreateContainer() {
  const { keycloak } = useKeycloak();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (
      createData: CreateContainerData
    ): Promise<CreateContainerResponse> => {
      const response = await fetch(
        `${
          import.meta.env.VITE_USER_ENGINE_ENDPOINT
        }/api/v1/bundles/user_bundle/functions/update_container`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${keycloak.token}`,
          },
          method: 'POST',
          body: JSON.stringify({
            name: createData.name,
            schemaUuid: createData.schemaUuid || null,
            containerUuid: null,
            dynamic: createData.dynamic || false,
          }),
        }
      );

      const data = await response.json();

      return {
        uuid: data?.data.message,
      };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['userContainers'],
      });
    },
  });
}
